import logo from './logo.svg';
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import { SeiWalletProvider, useWallet, WalletConnectButton } from '@sei-js/react';
import { SigningCosmWasmClient } from '@cosmjs/cosmwasm-stargate';
import { SocialIcon } from 'react-social-icons';
import Papa from 'papaparse';


const rpcUrl = 'https://sei.public-rpc.com'; // Replace with your RPC URL
const restUrl = 'https://rest.atlantic-2.seinetwork.io/'; // Replace with your REST URL
const chainId = 'pacific-1'; // Replace with your chain ID, e.g., 'atlantic-2'




const ChartSelectionList = ({ selectedChart, onSelectChart, chartList }) => {
  return (
    <>
      <div className="chart-selection-title">BTC Risk Metric</div>
      <div className="chart-selection-list">
        {chartList.map((file, index) => {
          const displayName = file.replace('.html', '');
          return (
            <div
              key={index}
              className={`chart-item ${selectedChart === `charts/${file}` ? 'selected' : ''}`}
              onClick={() => onSelectChart(file)}>
              {displayName}
            </div>
          );
        })}
      </div>
    </>
  );
};



const MainApp = () => {
	const [selectedChart, setSelectedChart] = useState('');
	const [chartList, setChartList] = useState([]);
	const [isNftOwner, setIsNftOwner] = useState(false);
	const { connectedWallet, accounts } = useWallet();
	const [showChartInfo, setShowChartInfo] = useState(false);
	const [ownedNFTs, setOwnedNFTs] = useState([]);
	const [formStep, setFormStep] = useState(0); // To control the form steps
	const [formData, setFormData] = useState({
	  submissionDate: new Date().toISOString().slice(0, 10), // Captures the current date in YYYY-MM-DD format
	  email: '', // To store the user's email
	  selectedNFT: '', // To store the selected NFT ID
	  prefInt: '1',
	  numDays: '2',
	  orderedExercises: [],
	  mainLifts: [],
	  maxWeights: {},
	  materials: []
	});



	const [nftOptions, setNftOptions] = useState([]); // To hold the fetched NFT options

	// function to submit the data of the form
	const handleSubmitForm = async () => {
	  const lastSubmissionDate = nftSubmissionDates[formData.selectedNFT];
	  if (lastSubmissionDate !== 'No Submission' && !isMoreThanThreeWeeksAgo(lastSubmissionDate)) {
		alert('You cannot submit a new request for this NFT yet. Please wait until it has been more than three weeks since the last submission.');
		return; // Prevent form submission
	  }

	  // Prepare the data to be sent
	  const submissionData = {
		submissionDate: formData.submissionDate,
		email: formData.email,
		selectedNFT: formData.selectedNFT,
		prefInt: formData.prefInt,
		numDays: formData.numDays,
		orderedExercises: JSON.stringify(formData.orderedExercises), // Serialize array
		mainLifts: JSON.stringify(formData.mainLifts), // Serialize array
		maxWeights: JSON.stringify(formData.maxWeights), // Serialize object
		materials: JSON.stringify(formData.materials), // Serialize array
	  };

		console.log(formData.prefInt);

		fetch('https://script.google.com/macros/s/AKfycbwYuv6DO2P8FZ2FTEACpr1Q-lOM5KwWWYqvp8M0dUMkab98NMKTVk3pDj6wXp4TbSjx-Q/exec', {
		method: 'POST',
		contentType: 'application/json',
		body: JSON.stringify(submissionData),
	  })
	  .then(response => response.json())
	  .then(data => console.log(data))
	  .catch(error => console.error('Error:', error));

	  // Additional submission handling logic...
	


	  // Simply toggle the summary view without resetting the formData
	  setShowSummary(true);
	};


	// component that takes the form data as props and renders a summary
	const FormSummary = ({ data }) => {
	  return (
		<>
		  <h4>Keep an eye on your inbox!<br/>We will try to get the program to you within 48h!</h4>
		</>
	  );
	};

	// manage the visibility of the summary
	const [showSummary, setShowSummary] = useState(false);

	// functions to handle changes in the form fields and to navigate between the form steps
	
	const handleFormDataChange = (field, value) => {
	  setFormData({ ...formData, [field]: value });
	};

	const nextStep = () => {
	  if (formStep === 0) {
		const lastSubmissionDate = nftSubmissionDates[formData.selectedNFT];
		// Allow proceeding if there's no previous submission or it's been more than three weeks
		if (lastSubmissionDate && !isMoreThanThreeWeeksAgo(lastSubmissionDate)) {
		  alert('You cannot submit a new request for this NFT yet. Please wait until it has been more than three weeks since the last submission.');
		  return; // Prevent moving to the next step
		}
	  }
	  
	  const { isValid, errorMessage } = validateCurrentStep(formStep);
	  if (isValid) {
		setFormStep(formStep + 1);
	  } else {
		alert(errorMessage); // Or display the error message in the UI
	  }
	};


	const prevStep = () => {
	  setFormStep(formStep - 1);
	};


	// Defining excercise data
	
	const exerciseOptions = [
	  { id: 'backsquat', name: 'Backsquat', lift_1: 'Backsquat', lift_2: null },
	  { id: 'frontsquat', name: 'Frontsquat', lift_1: 'Frontsquat', lift_2: null },
	  { id: 'deadlift', name: '(Sumo) Deadlift', lift_1: 'Deadlift', lift_2: null },
	  { id: 'ohp_pullup', name: 'OHP & vertical pull', lift_1: 'Pull-up', lift_2: 'Overhead Press' },
	  { id: 'bench_borow', name: 'Bench & BO row', lift_1: 'Bent-over Row', lift_2: 'Bench Press' }
	];



	const [tempExerciseSelections, setTempExerciseSelections] = useState([]);

	const handleExerciseSelection = (exercise) => {
	  if (tempExerciseSelections.length < formData.numDays) {
		const newSelections = [...tempExerciseSelections, exercise];

		// Ensure default reps for the newly selected exercise
		exercise = { ...exercise, lift_1_reps: exercise.lift_1_reps || "1" }; // Default reps for lift 1
		if (exercise.lift_2) {
		  exercise = { ...exercise, lift_2_reps: exercise.lift_2_reps || "1" }; // Default reps for lift 2, if exists
		}

		setTempExerciseSelections(newSelections);

		// Update formData to include this exercise with default reps
		setFormData(prevFormData => ({
		  ...prevFormData,
		  orderedExercises: newSelections.map(e => e.id), // Store only the IDs in order
		  mainLifts: [...prevFormData.mainLifts, exercise] // Add the exercise with default reps
		}));
	  } else {
		alert('You have selected exercises for all your training days.');
	  }
	};


	const confirmExerciseOrder = () => {
	  setFormData({ ...formData, orderedExercises: tempExerciseSelections });
	  nextStep(); // Move to the next step after confirming the order
	};




	// Handle changes for max weights and reps similarly to other form data, ensuring you capture these details within the formData structure
	const handleMaxWeightChange = (e, liftId, liftType) => {
	  const updatedLifts = formData.mainLifts.map(lift => {
		if (lift.id === liftId) {
		  return { ...lift, [`${liftType}_max_weight`]: e.target.value };
		}
		return lift;
	  });
	  setFormData({ ...formData, mainLifts: updatedLifts });
	};

	const handleRepsChange = (e, liftId, liftType) => {
	  const updatedLifts = formData.mainLifts.map(lift => {
		if (lift.id === liftId) {
		  return { ...lift, [`${liftType}_reps`]: e.target.value };
		}
		return lift;
	  });
	  setFormData({ ...formData, mainLifts: updatedLifts });
	};
	


  // Function to toggle chart interpretation visibility
  const toggleChartInfo = () => {
    setShowChartInfo(!showChartInfo);
  };

  // Function to check if the user's wallet is in the owners list
	const checkNftOwnership = async (walletAddress) => {
		const rpcEndpoint = "https://sei-rpc.publicnode.com:443";
		const collectionAddress = "sei1m3jgjyzcxtlv9n5yca5mkh8kze5800wv79a6k3punuexv83gxggs62mefw";

		const client = await SigningCosmWasmClient.connect(rpcEndpoint);

		let startTokenId = 1; // Start from token ID 1

		try {
			await client.queryContractSmart(collectionAddress, {
				owner_of: { token_id: '0' }
			});
			startTokenId = 0; // token ID 0 exists, start from 0
		} catch (error) {
			// assuming an error means Token ID 0 does not exist
		}

		const ownedNfts = [];

		while (true) {
			const query = {
				tokens: {
					owner: walletAddress,
					start_after: startTokenId.toString(), // Start after the last token ID
				},
			};

			try {
				const response = await client.queryContractSmart(collectionAddress, query);

				if (response.tokens.length > 0) {
					ownedNfts.push(...response.tokens);
					startTokenId = parseInt(response.tokens[response.tokens.length - 1]) + 1;
				} else {
					break; // No more NFTs to retrieve
				}
			} catch (error) {
				console.error("Error querying NFT ownership:", error);
				break;
			}
		}

		return ownedNfts;
	};


	// Transform ownedNfts into a suitable format for a dropdown, e.g., [{ id: NFT ID, label: NFT Name }, ...]
	useEffect(() => {
	  if (connectedWallet && accounts[0]?.address) {
		checkNftOwnership(accounts[0].address)
		  .then((ownedNfts) => {
			if (ownedNfts.length > 0) {
			  setIsNftOwner(true);
			  // Assuming ownedNfts is an array of IDs
			  const options = ownedNfts.map(id => ({ id, label: `${id}` }));
			  setNftOptions(options);
			  
			  // Automatically select the first NFT if the list is not empty
			  setFormData(prevFormData => ({
				...prevFormData,
				selectedNFT: options[0].id, // Set the selectedNFT to the first NFT's ID
			  }));
			  
			} else {
			  setIsNftOwner(false);
			}
		  })
		  .catch((error) => console.error('Error checking NFT ownership:', error));
	  }
	}, [connectedWallet, accounts]);




	useEffect(() => {
		if (connectedWallet && accounts[0]?.address) {
			checkNftOwnership(accounts[0].address)
				.then((ownedNfts) => {
					if (ownedNfts.length > 0) {
						setIsNftOwner(true);
						setOwnedNFTs(ownedNfts); // Store the list of owned NFTs
					} else {
						setIsNftOwner(false);
					}
				})
				.catch((error) => console.error('Error checking NFT ownership:', error));
		}
	}, [connectedWallet, accounts]);



	// Function to fetch the updated list of charts
	const fetchChartList = async () => {
	  try {
		const response = await fetch('/chartlist/chartList.json');
		const data = await response.json();
		setChartList(data.htmlFiles); // Use the array for setting the state
	  } catch (error) {
		console.error('Error fetching chart list:', error);
	  }
	};



  
	// Function to handle selecting a chart
	const handleSelectChart = (chart) => {
	  setSelectedChart(`charts/${chart}`); // Keep the .html extension
	};


  // Fetch the chart list when the component mounts
  useEffect(() => {
    fetchChartList();
  }, []);



	// Example validation function
	const validateCurrentStep = (currentStep) => {
	  let isValid = true;
	  let errorMessage = "";

	  switch (currentStep) {
		case 0: // Validate NFT selection and email
		  if (!formData.email.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/)) {
			isValid = false;
			errorMessage = "Please enter a valid email address.";
		  }
		  break;
		  
		case 1: // Validate intensity preference
		  // Assuming prefInt is always valid due to being a dropdown
		  break;
		  
		case 2: // Validate training days
		  if (!["2", "3", "4", "5"].includes(formData.numDays)) {
			isValid = false;
			errorMessage = "Please select a number between 2 and 5.";
		  }
		  break;
		  
		case 3: // Validate exercises selection
		  if (formData.orderedExercises.length < formData.numDays) {
			isValid = false;
			errorMessage = "Please select exercises for all training days.";
		  }
		  break;
		  
		case 4: // Validate weights and reps
			const isValidLifts = formData.mainLifts.every(lift => {
				// Automatically consider Pull-Up valid
				if (lift.lift_1 === 'Pull-up') {
					return true;
				}

				// Check for valid weight for lift 1
				const hasValidLift1Weight = lift.lift_1_max_weight && lift.lift_1_max_weight > 0;
				const hasValidLift1Reps = ["1", "2", "3", "4", "5"].includes(lift.lift_1_reps.toString());
				
				// If lift 2 exists, validate its weight and reps; otherwise, treat it as valid
				const hasValidLift2 = lift.lift_2 ? 
					(lift.lift_2_max_weight && lift.lift_2_max_weight > 0) && 
					["1", "2", "3", "4", "5"].includes(lift.lift_2_reps.toString()) : 
					true;

				return hasValidLift1Weight && hasValidLift1Reps && hasValidLift2;
			});

			if (!isValidLifts) {
				isValid = false;
				errorMessage = "Please ensure all lifts have valid weights and reps.";
			}
			break;

		default:
		  break;
	  }

	  return { isValid, errorMessage };
	};
	
	
	// Function to check if all exercises have valid weights and reps
	const isFormValidForSubmission = () => {
	  // Check if all required fields are filled (adjust according to your form's requirements)
	  const basicChecks = formData.email && formData.selectedNFT && formData.orderedExercises.length > 0;
	  
	  // Check if every exercise has valid weights and reps
	  const exercisesValid = formData.mainLifts.every(exercise => {
		const hasValidLift1Weight = exercise.lift_1_max_weight && exercise.lift_1_max_weight > 0;
		const hasValidLift1Reps = exercise.lift_1_reps && exercise.lift_1_reps > 0 && exercise.lift_1_reps <= 5;
		
		let hasValidLift2 = true;
		if (exercise.lift_2) {
		  const hasValidLift2Weight = exercise.lift_2_max_weight && exercise.lift_2_max_weight > 0;
		  const hasValidLift2Reps = exercise.lift_2_reps && exercise.lift_2_reps > 0 && exercise.lift_2_reps <= 5;
		  hasValidLift2 = hasValidLift2Weight && hasValidLift2Reps;
		}
		
		return hasValidLift1Weight && hasValidLift1Reps && hasValidLift2;
	  });
	  
	  return basicChecks && exercisesValid;
	};

	
	
	

	// Fetching and Parsing CSV Data
	useEffect(() => {
	  const fetchCsvData = () => {
		const csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vS3uI6foowHzbgFEhXY_wRKsPfU92ocb1S4S7rp-V0LtQhu20LmEJaPIOVXHwmXKRZNJnn-s_KwVepG/pub?gid=0&single=true&output=csv';

		Papa.parse(csvUrl, {
		  download: true,
		  header: true, // First row of the CSV is assumed to be headers
		  complete: (results) => {
			const csvData = results.data;
			compareNftDates(csvData); // Function to compare dates
		  },
		  error: (error) => {
			console.error("Error loading CSV data: ", error);
		  }
		});
	  };

	  if (ownedNFTs.length > 0) {
		fetchCsvData();
	  }
	}, [ownedNFTs, formData.selectedNFT]); // Dependency array to rerun when ownedNFTs changes


	// state to hold the mapping of NFT IDs to their latest submission dates
	const [nftSubmissionDates, setNftSubmissionDates] = useState({});


	// Matching NFT IDs and Extracting Dates
	const compareNftDates = (csvData) => {
	  const nftDateMap = ownedNFTs.reduce((acc, nftId) => {
		const relevantEntries = csvData.filter(entry => entry.selectedNFT === nftId.toString());
		relevantEntries.sort((a, b) => new Date(b.submissionDate) - new Date(a.submissionDate));
		const latestEntry = relevantEntries[0];
		acc[nftId] = latestEntry ? latestEntry.submissionDate : 'No Submission';
		return acc;
	  }, {});

	  setNftSubmissionDates(nftDateMap);
	};

	// Utility function to check if the date is more than three weeks ago
	const isMoreThanThreeWeeksAgo = (dateString) => {
	  const submissionDate = new Date(dateString);
	  const threeWeeksAgo = new Date();
	  threeWeeksAgo.setDate(threeWeeksAgo.getDate() - 21); // Set to 21 days ago
	  return submissionDate < threeWeeksAgo;
	};


	// Set Pull-up values, just before rendering formStep === 4
	useEffect(() => {
	  formData.mainLifts.forEach((lift) => {
		if (lift.lift_1 === 'Pull-up') {
		  // Automatically set default values for Pull-Up
		  const defaultWeight = '10'; // Default weight for Pull-up
		  const defaultReps = '1'; // Default reps for Pull-up

		  // Check if values are already set to prevent unnecessary updates
		  if (lift.lift_1_max_weight !== defaultWeight) {
			const fakeEventWeight = { target: { value: defaultWeight }};
			handleMaxWeightChange(fakeEventWeight, lift.id, 'lift_1');
		  }
		  if (lift.lift_1_reps !== defaultReps) {
			const fakeEventReps = { target: { value: defaultReps }};
			handleRepsChange(fakeEventReps, lift.id, 'lift_1');
		  }
		}
	  });
	}, [formStep, formData.mainLifts]); // Trigger this effect on form step change






  return (
    <>
		<div className="banner">
		  {/* Banner content here */}
		</div>
		
		
      <div className="header-container">
        <div className="social-icons">
          <SocialIcon url="https://twitter.com/Seitama_NFT" />
          <SocialIcon url="https://discord.gg/568cYGCExa" />
        </div>

        <div className="wallet-button-container">
          {!connectedWallet ? (
            <div className="custom-wallet-connect-button">
              <WalletConnectButton />
            </div>
          ) : (
            <p>Connected to: {accounts[0]?.address}</p>
          )}
        </div>
      </div>
	
      <div className="title-container">
        <h1 className="title">Exclusive Crypto Analyses for the Real Seitama Hero Association</h1>
      </div>
	  

          
      <div className="info-section">
        <p className="center-text">
          This page is where Real Seitama holders will have exclusive access to our crypto analyses. <br />
		  We are currently launching this site as a beta version, as the Real Seitama team is hard at work creating valuable and unique analysis to reward our holders. <br />
		  Expect this site to grow, change shape, and expand as more analyses are added <br />
		  If you have any suggestions, feel free to join our <a href="https://discord.gg/568cYGCExa">Discord</a> and reach out! <br />
		  <br />
		  For now, in this beta phase, Real Seitama holders can explore a detailed and unique "risk" analysis of Bitcoin's price over time.<br />
          The analysis utilizes various colors to denote different levels of risk and employs a logarithmic regression model for predictions.<br />
          Notably, the chart adopts a logarithmic scale to effectively represent a broad range of data points.
        </p>
        
      <div className="subtitle-image-container">
		  <div className="subtitle-with-image" onClick={toggleChartInfo}>
			<h2 className={`subtitle ${showChartInfo ? 'expanded' : ''}`}>
			  How to Interpret the Chart
			</h2>
			<img 
			  src="click_me.png" 
			  alt="Click me" 
			  className="clickable-image"
			  onClick={toggleChartInfo} 
			/>
		  </div>
		</div>

		
        <div className={`chart-info-container ${showChartInfo ? 'expanded' : 'collapsed'}`}>
			{showChartInfo && (
			  <>
				<p className="center-text"><strong>Bitcoin Price Trajectory</strong> The fluctuating "wiggly" line depicts the actual historical price of Bitcoin, illustrating market growth and declines. <br />
				The y-axis displays the year, while the x-axis visualizes the Bitcoin price in USD on a logarithmic scale, facilitating the visualization of exponential growth.<br />A logarithmic scale helps us see Bitcoin's price changes clearly, even though they vary widely.</p>
				<p className="center-text"><strong>Logarithmic Regression Trend Line</strong> Represented by a dashed grey line, this trend line is derived from a logarithmic regression model, predicting the price trajectory over time.</p>
				<p className="center-text"><strong>Adjusted R² and p-value</strong> These statistical measures evaluate the model's accuracy, with an R² indicating how well a model "fits", and a p-value showing statistical significance. <br />
				Adjusted R² tells us how well our model's predictions match the actual prices. A number close to 1 means a close match.<br />
				The p-value indicates the reliability of our model's predictions, with a value below 0.01 indicating strong statistical significance.</p>
				<p className="center-text"><strong>Quantile Bands</strong> Dotted lines in various colors indicate different quantiles of price predictions, offering insights into potential price bounds.<br />
				These bands show the range where, assuming historical prices are valid to predict future prices, Bitcoin could rise or fall to. The closer to the top or bottom band, the more "unusual" the price.</p>
				<p className="center-text"><strong>Risk Levels</strong> Colors on the price line indicate risk levels at specific times, with darker reds for higher risk and greens for lower risk.<br />
				One could interpret this risk from the perspective: "given Bitcoin's past price movements, how room to move lower/higher does Bitcoin's price potentially have?"<br />
				Keep in mind however that the analysis inherently only can look at 'past' price movements, and thus is inherenlty retrospective.</p>
				<p className="center-text"><strong>Halving Dates</strong> Vertical light blue lines mark Bitcoin halving events, significant for their impact on Bitcoin's supply and potential price changes.<br />
				Should you detect any specific patterns in Bitcoins price movements, you could use key events such as halvings to put these potential patterns in perspective</p>
				<p className="center-text"><strong>Annotations</strong> A box includes statistical measures such as current and predicted prices, enhancing the chart's informational value.</p>
			  </>
			)}
		</div>
        
        <p className="center-text">
          Utilizing this chart, Seitama holders gain insights into Bitcoin's historical and potential future price movements, understanding the associated risk levels and the current price's position relative to model predictions.<br />
		  However, it's crucial to recognize the limitations of predictive models in the inherently volatile cryptocurrency market.<br />
		  Keep in mind, past performance of Bitcoin price is not indicative of future results.<strong>"All models are wrong, some are useful"</strong>
        </p>
      </div>
	  
	  {isNftOwner ? (
	  // Content to display when the user is a confirmed NFT owner
		  <>
			<div className="button-container">
			  <button
				onClick={() => setSelectedChart('')} // Reset selected chart when button is clicked
				className={`content-button ${selectedChart === '' ? 'selected' : ''}`}
			  >
				Take me to the crypto analyses
			  </button>
			  <button
				onClick={() => setSelectedChart('workout')} // Set 'workout' when button is clicked
				className={`content-button ${selectedChart === 'workout' ? 'selected' : ''}`}
			  >
				I want a 6-week workout schedule
			  </button>
			</div>
			<div className="display-container">
			  {selectedChart === 'workout' ? (
				// Content for the 'workout' option
				// Show Summary after submission
				showSummary ? (
					  <FormSummary data={formData} />
					) : (
						
						  <div className="workout-content">

							{formStep === 0 && (
							  <>
								<h2>Select the ID of the NFT you want to use</h2>
								<p >You can only use each NFT once every three weeks.<br />
								This is just an initial check, and takes a few minutes to update to the correct date.<br />
								If you submit multiple requests within three weeks, the latter ones will just be ignored. </p>
								<select
								  value={formData.selectedNFT}
								  onChange={(e) => handleFormDataChange('selectedNFT', e.target.value)}
								>
								  {nftOptions.map(option => (
									<option key={option.id} value={option.id}>{option.label}</option>
								  ))}
								</select>
								{/* Display the last submission date for the selected NFT */}
								{formData.selectedNFT && (
								  <div>Last submission date: {nftSubmissionDates[formData.selectedNFT] || 'No submissions yet'}</div>
								)}

								<h2>To what email should we send the program?</h2>
								<p >Feel free to use a burner-email, we don't have to reach out later.<br />
								We just need an email adres to send the PDF containing your program.<br />
								Good practices to open any file from a stranger is to do one of or all of the following:<br />
								Open the PDF in a VM | Run the PDF through a virus scan | use a tool to analyse the PDF</p>
								<input
								  type="email"
								  name="email" // Suggests to the browser this field is specifically for email addresses
								  autoComplete="email" // Helps browsers use autofill with stored email addresses
								  value={formData.email}
								  onChange={(e) => handleFormDataChange('email', e.target.value)}
								  placeholder="Your email address"
								/>

								<button onClick={nextStep}>Next</button>
							  </>
							)}

						  
						  
						  
						  
							{formStep === 1 && (
							  <>
								  <h2>Select Intensity</h2>
								  <p>The full program consists of 12 weeks of training. Using your SeitamaNFT you can generate one half (6 weeks) every three weeks.<br/>
								  This means you can generate the first 6 weeks (higher volume = more reps with relatively less weight), <br/>
								  or the last 6 weeks (higher intensity = less reps with relatively higher weight). <br/>
								  For optimal strength results, it's recommended to first do the "higher volume" variant, followed by the "higher intensity" variant.<br/>
								  Choose your preferred intensity level for the program:</p>
								  
									<select
									  required
									  value={formData.prefInt}
									  onChange={(e) => handleFormDataChange('prefInt', e.target.value)}
									>
									  <option value="1">Higher volume</option>
									  <option value="2">Higher intensity</option>
									</select>

								<button onClick={prevStep}>Back</button>
								<button onClick={nextStep}>Next</button>
								</>
							)}
							
							{formStep === 2 && (
							  <>
								<h2>How many days per week do you want to train? (2-5)</h2>
								  <select
									required
									value={formData.numDays}
									onChange={(e) => handleFormDataChange('numDays', e.target.value)}
								  >
									<option value="2">2</option>
									<option value="3">3</option>
									<option value="4">4</option>
									<option value="5">5</option>
								  </select>
								<button onClick={prevStep}>Back</button>
								<button onClick={nextStep}>Next</button>
							  </>
							)}

							
							{formStep === 3 && (
							  <>
								<h2>Select Your Exercises for Each Training Day</h2>
								<p>Select your preferred excercise groups<br/>
								  You can pick one group for each of the amount of days per week you want to train</p>
								{exerciseOptions.map((exercise, index) => (
								  <div key={index} onClick={() => handleExerciseSelection(exercise)}>
									<button>{exercise.name}</button>
								  </div>
								))}
								{tempExerciseSelections.length > 0 && (
								  <>
									<h3>Selected Exercises:</h3>
									<ol>
									  {tempExerciseSelections.map((exercise, index) => (
										<li key={index}>{exercise.name}</li>
									  ))}
									</ol>
									<button onClick={confirmExerciseOrder}>Confirm Order</button>
								  </>
								)}
								<button onClick={prevStep}>Back</button>
							  </>
							)}

							
							{formStep === 4 && (
							  <>
								<h2>Input Max Weights and Reps</h2>
								<p>Please enter the (estimated) maximum amount of weight that you can lift for 1 to 5 repetitions.<br/>
								  When creating the program, we will use these weights as reference to build your customized schedule.</p>
								{formData.mainLifts.map((lift, index) => (
								  <div key={index}>
									{lift.lift_1 && lift.lift_1 !== 'Pull-up' && ( // Check if the lift is not a pull-up
									  <>
										<h3>{lift.lift_1}</h3>
										<input
										  type="number"
										  min="1"
										  step="1"
										  placeholder={`Max weight for ${lift.lift_1}`}
										  onChange={(e) => handleMaxWeightChange(e, lift.id, 'lift_1')}
										  required
										/>
										<select
										  required
										  value={lift.lift_1_reps || '1'} // Default to '1' or current value
										  onChange={(e) => handleRepsChange(e, lift.id, 'lift_1')}
										>
										  <option value="1">1 rep</option>
										  <option value="2">2 reps</option>
										  <option value="3">3 reps</option>
										  <option value="4">4 reps</option>
										  <option value="5">5 reps</option>
										</select>
									  </>
									)}
									{lift.lift_2 && (
									  <>
										<h3>{lift.lift_2}</h3>
										<input
										  type="number"
										  min="1"
										  step="1"
										  placeholder={`Max weight for ${lift.lift_2}`}
										  onChange={(e) => handleMaxWeightChange(e, lift.id, 'lift_2')}
										  required
										/>
										<select
										  required
										  value={lift.lift_2_reps || '1'} // Default to '1' or current value
										  onChange={(e) => handleRepsChange(e, lift.id, 'lift_2')}
										>
										  <option value="1">1 rep</option>
										  <option value="2">2 reps</option>
										  <option value="3">3 reps</option>
										  <option value="4">4 reps</option>
										  <option value="5">5 reps</option>
										</select>
									  </>
									)}
								  </div>
								))}
								<button onClick={prevStep}>Back</button>
								<button onClick={handleSubmitForm} disabled={!isFormValidForSubmission()}>Submit</button>
							  </>
							)}

							
							
						  </div>
						)
					

				
			  ) : (
				// Content for the 'crypto analyses' option
				<>
				  <ChartSelectionList
					selectedChart={selectedChart}
					onSelectChart={handleSelectChart}
					chartList={chartList}
				  />
				  {selectedChart && (
					<iframe
					  src={selectedChart}
					  title="Chart Display"
					  className="chart-display"
					/>
				  )}
				</>
			  )}
			</div>
		  </>
	  ) : (
        // Content to display when the user is not a confirmed NFT owner or check is not done
        <div className="non-owner-content">
          <p>You haven't connected your wallet, or you do not currently own any NFTs in this collection. <br />
		  Go get a Real Seitama NFT, and join the hero association!</p>
          <p className="non-owner-content-ps">P.S.: If you just got a Real Seitama NFT, give it some time <br />
		  Due to database updates and RPC load, it can take a few minutes to an hour to recognise it if it's fresh in your wallet.</p>
        </div>
	  )}
	  

  	  
    </>
	

	
  );
};

const App = () => {
  return (
    <SeiWalletProvider chainConfiguration={{ chainId, restUrl, rpcUrl }} wallets={['compass', 'fin']}>
      <MainApp />
    </SeiWalletProvider>
  );
};


export default App;